const choices = {
    lessThan: 'Moins de 5 ans',
    between: 'Entre 5 et 8 ans',
    moreThan: 'Plus de 8 ans',
};

export default choices;
